const m = require('moment')

const escape = (str = '') => str.replace(/([^\\])'/g, '$1\\\'')

const operators = {
  '=': 'eq',
  '!=': 'ne',
  '>': 'gt',
  '>=': 'ge',
  '<': 'lt',
  '<=': 'le'
}

const typeConvert = (value, operator, type) => {

  if(value === null) return 'NULL'
  if(['CURRENCY', 'NUMBER', 'DOUBLE', 'INTEGER'].includes(type)) return value
  if(['DATETIME'].includes(type) && typeof value === 'number') return `'DateTime'${m(value).format('YYYY-MM-DDThh:mm:ss')}'`
  if(typeof value === 'string') return `'${escape(value)}'`
  
  return value
}


const buildFilter = where =>
  where && where.whereClauseOrder && where.whereClauseOrder.toLowerCase().split(/(\d)+/).map( t => {
    let i = parseInt(t) - 1
    if(parseInt(t) !== NaN && where.rules.length >= i && i >= 0) {
      let r = where.rules[i]
      if(!r || !r.leftField || !r.leftField.fieldPath || !r.leftField.fieldPath.length || !(r.operator in operators)) return null
      
      return [r.leftField.fieldPath, operators[r.operator], typeConvert(r.rightValue, r.operator, r.leftField.type)].join(' ')
    }
    return t
  }).filter(t => t).join(' ')

const toOdata = ({orderby, where, limit = 100}) => {
  let odataQuery = '$top=' + limit
  
  if (orderby && orderby.length) {
    odataQuery += '&$orderby=' + orderby.join(',')
  }
  
  if(where && where.whereClauseOrder.length) {
     const filter = buildFilter(where)
     odataQuery += filter ? `&$filter=${filter}` : ''
  }

  return odataQuery
}

module.exports = toOdata
